import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { CareerPathSearchParams } from '@backrs_ui/grow-ui/src/models/models';

type CareerPathSearchState = Readonly<{
  sections: Record<string, CareerPathSearchParams>;
}>;

const initialState: CareerPathSearchState = {
  sections: {},
};

export const careerPathSearchStateSlice = createSlice({
  name: 'careerPathSearch',
  initialState,
  reducers: {
    setSearchParamsForSection: (
      state,
      action: PayloadAction<{ sectionName: string; searchParams: CareerPathSearchParams }>,
    ) => {
      state.sections[action.payload.sectionName] = {
        ...action.payload.searchParams,
        hasInitialSearchBeenMade: true,
      };
    },
    resetSearchParamsForSection: (state, action: PayloadAction<string>) => {
      state.sections[action.payload] = {
        searchTerm: '',
        selectedFilters: [],
        searchResults: undefined,
        hasInitialSearchBeenMade: true,
      };
    },
  },
});

export const { setSearchParamsForSection, resetSearchParamsForSection } =
  careerPathSearchStateSlice.actions;

export const careerPathSearchReducer = careerPathSearchStateSlice.reducer;
